// Import Vendors
import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
import FarloUiNumberInput from './vendors/farlo-ui-numberinput.js';
import FarloUiList from './vendors/farlo-ui-list.js';
import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel';
import FarloUiTicketCalendar from './vendors/farlo-ui-ticket-calendar';
import addLightboxToGallery from './vendors/farlo-ui-gallery-lightbox.js';
import { farloUiRevolverFlickityCarousel } from './components/footer/farlo-ui-revolver-flickity-carousel.js';
import FarloUiMarquee from './vendors/farlo-ui-marquee.js';

// Import Footer Components
import { farloUiCrmSignup } from './components/footer/farloUiCrmSignup.js';
import { elementInView } from './components/footer/elementInView.js';
import { toggleFAQ } from './components/footer/toggleFAQ.js';
import { faqs } from './components/footer/faqs.js';
import { navigation, navicon } from './components/footer/navigation.js';
import { smoothScrollToAnchor } from './components/footer/smoothScrollToAnchor.js';
import { embedOverlay } from './components/footer/embedOverlay.js';
import { mapLoader } from './components/footer/mapLoader.js';

((document, window, history) => {
	const pushState = history.pushState;

	history.pushState = function (state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};
	function frontPagePopup() {
		const popup = document.querySelector('.frontpage__popup');
		const popupInner = document.querySelector('.frontpage__popup-inner');
		const closeButton = document.querySelector('.frontpage__popup-button');
		const popupCookieName = 'frontpagePopupSeen';

		// Show the popup
		function showPopup() {
			popup.style.display = 'flex';
		}

		// Hide the popup
		function hidePopup() {
			popup.style.display = 'none';
			setCookie(popupCookieName, 'true', 1); // Set cookie for 30 days
		}

		// Set a cookie
		function setCookie(name, value, days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			const expires = 'expires=' + date.toUTCString();
			document.cookie = name + '=' + value + ';' + expires + ';path=/';
		}

		// Get a cookie
		function getCookie(name) {
			const nameEQ = name + '=';
			const ca = document.cookie.split(';');
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) === ' ') {
					c = c.substring(1, c.length);
				}
				if (c.indexOf(nameEQ) === 0) {
					return c.substring(nameEQ.length, c.length);
				}
			}
			return null;
		}

		// Add event listener for the close button
		closeButton.addEventListener('click', function () {
			hidePopup();
		});

		// Hide the popup if click outside of popupInner
		popup.addEventListener('click', function (event) {
			if (!popupInner.contains(event.target)) {
				hidePopup();
			}
		});

		// Show the popup if cookie is not set
		if (!getCookie(popupCookieName)) {
			showPopup();
		}
	}

	document.addEventListener('DOMContentLoaded', () => {

		if (document.querySelector('.frontpage__popup')) {
			frontPagePopup();
		}

		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document
				.querySelectorAll('.site-navigation__sub-menu')
				.forEach((_sel) => {
					navigation(_sel);
				});
		}

		if (document.querySelector('.farlo-ui-crm--inline')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			document
				.querySelectorAll('[farlo-ui="flickity-carousel"]')
				.forEach((_sel) => {
					farloUiRevolverFlickityCarousel(_sel);
				});
		}

		// Masonry-style marquees are static grids, so skip the slider
		if (document.querySelector('.farlo-ui-marquee:not(.is-style-masonry)')) {
			document.querySelectorAll('.farlo-ui-marquee:not(.is-style-masonry)').forEach((_sel) => {
				new FarloUiMarquee(_sel);
			});
		}

		if (document.querySelector('.is-style-lightbox-gallery, .farlo-ui-marquee.is-style-masonry')) {
			addLightboxToGallery();
		}

		if (document.querySelectorAll('.wp-block-embed')) {
			embedOverlay();
		}

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.farlo-ui-crm__toggle')) {
			const buttons = document.querySelectorAll('.farlo-ui-crm__toggle');
			const crmBlocks = document.querySelectorAll(
				'.farlo-ui-crm[farlo-ui="crm"]'
			);

			buttons.forEach(function (button) {
				let closestCrmBlock = null;
				let closestDistance = Infinity;

				crmBlocks.forEach(function (block) {
					const distance =
						button.getBoundingClientRect().top -
						block.getBoundingClientRect().top;
					if (distance > 0 && distance < closestDistance) {
						closestDistance = distance;
						closestCrmBlock = block;
					}
				});

				if (closestCrmBlock) {
					const crmId = closestCrmBlock.getAttribute('data-crm-id');
					button.setAttribute('data-crm-button-for', crmId);
				}
			});

			buttons.forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiCrmSignup(e);
				});
			});
		}

		if (document.querySelector('.farlo-ui-map')) {
			mapLoader();
		}

		// smoothScrollToAnchor();

		if (document.querySelector('.rank-math-list-item')) {
			document.querySelectorAll('.rank-math-question').forEach((_el) => {
				_el.dataset.toggled = '0';
				_el.addEventListener('click', () => {
					toggleFAQ(_el);
				});
			});
		}

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.farlo-ui-animated')) {
			document.querySelectorAll('.farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-ticket-calendar')) {
			document
				.querySelectorAll('[farlo-ui="calendar"]')
				.forEach((_sel) => {
					new FarloUiTicketCalendar(_sel);
				});
		}

		if (document.querySelector('select')) {
			document.querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
		}
		if (document.querySelector('input[type="number"]')) {
			document
				.querySelectorAll('input[type="number"]')
				.forEach((numberInput) => {
					new FarloUiNumberInput(numberInput);
				});
		}

		if (document.querySelector('.gfield_list_icons')) {
			document
				.querySelectorAll('.gfield_list_icons')
				.forEach(function (buttonContainer) {
					new FarloUiList(buttonContainer);
				});
		}

		if (document.querySelector('.farlo-ui-lightbox__toggle')) {
			document
				.querySelectorAll('.farlo-ui-lightbox__toggle')
				.forEach((_sel) => {
					new FarloUiLightbox(_sel);
				});
		}

		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			document
				.querySelectorAll('[farlo-ui="carousel"]')
				.forEach((_sel) => {
					new FarloUiRevolverCarousel(_sel);
				});
		}

		const toggleLabel = (_lbl, toggle) => {
			if (toggle === 1) {
				_lbl.classList.add('farlo-ui-crm__label-hidden');
			} else {
				_lbl.classList.remove('farlo-ui-crm__label-hidden');
			}
		};
		document.querySelectorAll('.farlo-ui-crm__input').forEach((_inp) => {
			_inp.addEventListener('focus', () => {
				toggleLabel(_inp.parentElement, 1);
			});
			_inp.addEventListener('blur', () => {
				if (_inp.value === '') {
					toggleLabel(_inp.parentElement, 0);
				}
			});
			if (_inp.value !== '') {
				toggleLabel(_inp.parentElement, 1);
			}
		});
	});
	try {
		if (
			typeof navigator !== 'undefined' &&
			navigator.serviceWorker &&
			typeof navigator.serviceWorker.getRegistrations === 'function'
		) {
			navigator.serviceWorker.getRegistrations().then((registrations) => {
				for (const reg of registrations) {
					reg.unregister();
				}
			});
		}
	} catch (e) {
		// Silently skip any failures
	}

	function getSource() {
		const urlParams = new URLSearchParams(window.location.search);
		const referrer = document.referrer;
		let source = 'Direct'; // default to direct
		if (referrer) {
			const referrerURL = new URL(referrer);
			if (referrerURL.hostname.match(/(google)|(bing)|(yahoo)/gi)) {
				source = 'Organic Search';
			} else if (
				referrerURL.hostname.match(/(facebook)|(instagram)|(twitter)/gi)
			) {
				source = 'Organic Social';
			} else {
				source = 'Referral - ' + referrerURL.hostname;
			}
		}
		// Check for UTM parameters
		if (urlParams.has('utm_medium')) {
			const utmMedium = urlParams.get('utm_medium').toLowerCase();
			switch (utmMedium) {
				case 'cpc':
				case 'ppc':
					source = 'Paid Search';
					break;
				case 'social':
					source = 'Social Media';
					break;
				case 'email':
					source = 'Email';
					break;
				default:
					source = 'Other Campaign - ' + utmMedium;
					break;
			}
		}
		return source;
	}
	if (!_farlo.storage.get('_farlo_source', 'session')) {
		_farlo.storage.set('_farlo_source', getSource(), 'session');
	}

	window.addEventListener('load', () => {
		document.body.classList.add('loaded');
	});
})(document, window, history);
